/**
 * =============================================================================
 * IDS CRM Web - The completion tick a check form carries
 * =============================================================================
 *
 * A form built in Settings > Check Forms can carry its own completion tick:
 * the 'check_completed' field in its Completion section ("Post Robot Check
 * Complete"). That tick IS the form's completion: the Log Work and sign-off
 * screens leave out their own fixed "Check complete" box and read the answer
 * instead, so an engineer confirms a form once (team report 2026-08-02 on
 * tickets; jobs and maintenance sign-off follow the same rule since
 * Gareth 2026-10-21). Its wording is the form's own, set in the editor.
 *
 * A form without the field keeps the screen's fixed box.
 * =============================================================================
 */

export const COMPLETION_FIELD_KEY = 'check_completed';

/** True when the form shows its own completion tick (a live field in a live section). */
export function formOwnsCompletion(schema) {
  return (schema?.sections || []).some(section => !section.archived
    && (section.fields || []).some(field => !field.archived && field.field_key === COMPLETION_FIELD_KEY));
}

/** Whether the form's own completion tick is ticked in these answers. */
export function completionTicked(answers) {
  const value = answers?.[COMPLETION_FIELD_KEY];
  return value === true || value === 'true';
}
